import { useState } from "react";
import styles from "./AttendanceForm.module.css";
import { ATTENDANCE_PRESENT, ATTENDANCE_ABSENT, ATTENDANCE_LATE, ATTENDANCE_EXCUSED } from "../constants";

export default function AttendanceForm({ job, users, onSave, onCancel }) {
  const signups = job.signups || [];
  const [attendance, setAttendance] = useState(() => {
    const initial = {};
    signups.forEach((uid) => {
      initial[uid] = job.attendance?.[uid] || ATTENDANCE_PRESENT;
    });
    return initial;
  });

  const getUserName = (uid) => {
    const u = users.find((x) => x.id === uid);
    return u ? `${u.name} (${u.badge})` : "Unknown";
  };

  const [saving, setSaving] = useState(false);

  const handleSave = async (completeJob) => {
    setSaving(true);
    try {
      await onSave(job.id, attendance, completeJob);
    } catch (err) {
      // Error is shown by parent toast — stay on form so user can retry
      setSaving(false);
    }
  };

  const isAlreadyCompleted = job.status === "completed";

  return (
    <div>
      <h2 className={styles.heading}>Record Attendance</h2>
      <p className={styles.subheading}>
        {job.title} - {job.date}
      </p>

      {signups.length === 0 ? (
        <p className={styles.empty}>No officers signed up for this job.</p>
      ) : (
        signups.map((uid) => (
          <div key={uid} className={styles.row}>
            <label htmlFor={`att-${uid}`} className={styles.name}>{getUserName(uid)}</label>
            <select
              id={`att-${uid}`}
              className={styles.select}
              value={attendance[uid]}
              onChange={(e) =>
                setAttendance((prev) => ({ ...prev, [uid]: e.target.value }))
              }
            >
              <option value={ATTENDANCE_PRESENT}>Present</option>
              <option value={ATTENDANCE_ABSENT}>Absent</option>
              <option value={ATTENDANCE_LATE}>Late</option>
              <option value={ATTENDANCE_EXCUSED}>Excused</option>
            </select>
          </div>
        ))
      )}

      <div className={styles.actions}>
        {!isAlreadyCompleted && (
          <button className={styles.saveBtn} onClick={() => handleSave(false)} disabled={saving}>
            Save Draft
          </button>
        )}
        <button className={styles.saveBtn} onClick={() => handleSave(true)} disabled={saving}>
          {isAlreadyCompleted ? "Update Attendance" : "Save & Complete Job"}
        </button>
        <button className={styles.cancelBtn} onClick={onCancel} disabled={saving}>
          Cancel
        </button>
      </div>
    </div>
  );
}
